import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
    'pk_live_51SSOO4I78YyRcYrYQonKIJgwXDYlwl0zTdHoq4ZnVKJ6SGvMd9qLmyC0mAOpSIhcgKtpe7Cc5DaVh8Ydba49Hdnw00siYIum3j'
);
